// extracted by mini-css-extract-plugin
export default {"container":"roles_container__m+f-U","actions":"roles_actions__z5JP0"};